import { FETCH_LOG_EVENTS_FOR_HISTORY_ENROLLMENT_UE, LOG_EVENTS_FOR_HISTORY_ENROLLMENT_UE_FIELDNAME } from 'automation-ui-log-events/api-client/queries/LogEventQueries';
import { useQuery } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
export const wireGetEnrollmentDetails = WrappedComponent => props => {
  const {
    enrollmentId,
    flowId
  } = props;
  if (!enrollmentId) {
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      logEvents: [],
      areLogEventsLoading: false
    }));
  }
  const {
    data: {
      [LOG_EVENTS_FOR_HISTORY_ENROLLMENT_UE_FIELDNAME]: logEvents = []
    } = {},
    error,
    loading
  } = useQuery(FETCH_LOG_EVENTS_FOR_HISTORY_ENROLLMENT_UE, {
    variables: {
      enrollmentId,
      flowId,
      isHybrid: false
    },
    fetchPolicy: 'cache-first',
    onCompleted: () => {}
  });
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    logEvents: logEvents,
    logEventsError: error,
    areLogEventsLoading: loading,
    enrollmentId: enrollmentId,
    flowId: flowId
  }));
};